import { render, staticRenderFns } from "./InvitationVip.vue?vue&type=template&id=397e2d4c&scoped=true"
import script from "./InvitationVip.vue?vue&type=script&lang=js"
export * from "./InvitationVip.vue?vue&type=script&lang=js"
import style0 from "./InvitationVip.vue?vue&type=style&index=0&id=397e2d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397e2d4c",
  null
  
)

export default component.exports